/* eslint-disable @nx/enforce-module-boundaries */
import {GTM_CUSTOM_EVENTS, GtmInitialize} from 'libs/shared/service/src/lib/models/gtm-initialize.model';

export class FacultyGtmInitialize extends GtmInitialize {
    constructor(
        user_id: string,
        user_email: string,
        user_fullname: string,

        // Institution data
        public institution_id: string,
        public institution_name: string
    ) {
        super(GTM_CUSTOM_EVENTS.AppReady, user_id, user_email, user_fullname, 'Faculty');
    }
}
